import { defineMessages, useIntl } from 'react-intl';
import classNames from 'classnames';

import {
    Button,
    ButtonColor,
    ButtonShape,
    ButtonSize,
    ButtonVariant,
    ChevronIcon,
} from '@jsmdg/yoshi';
import styles from './ImageGalleryControl.module.scss';

const messages = defineMessages({
    slideNext: {
        defaultMessage: 'Nächstes Bild',
    },
    slidePrev: {
        defaultMessage: 'Vorhergehendes Bild',
    },
});

type ImageGalleryControlProps = {
    readonly show: boolean;
    readonly currentSlide: number;
    readonly totalSlides: number;
    readonly onPrev: () => void;
    readonly onNext: () => void;
    readonly isDisabledNext: boolean;
    readonly isDisabledPrev: boolean;
};

const ImageGalleryControl = ({
    currentSlide,
    isDisabledNext,
    isDisabledPrev,
    onNext,
    onPrev,
    show,
    totalSlides,
}: ImageGalleryControlProps): JSX.Element => {
    const intl = useIntl();

    return (
        <div
            className={classNames(
                'mx-auto d-flex justify-content-between align-items-center position-absolute',
                styles.paginationControl,
                { [styles.hide]: !show },
            )}
        >
            <Button
                dataTestId="slide-prev"
                shape={ButtonShape.Icon}
                className="m-0-5x"
                onClick={onPrev}
                disabled={isDisabledPrev}
                variant={ButtonVariant.Contained}
                a11yText={intl.formatMessage(messages.slidePrev)}
                size={ButtonSize.Small}
                color={ButtonColor.BrandDark}
            >
                <ChevronIcon className={classNames(styles.icon, styles.navigationPrevIcon)} />
            </Button>
            <span className="fw-semibold">{`${currentSlide} / ${totalSlides}`}</span>
            <Button
                dataTestId="slide-next"
                shape={ButtonShape.Icon}
                className="m-0-5x"
                onClick={onNext}
                disabled={isDisabledNext}
                variant={ButtonVariant.Contained}
                a11yText={intl.formatMessage(messages.slideNext)}
                size={ButtonSize.Small}
                color={ButtonColor.BrandDark}
            >
                <ChevronIcon className={classNames(styles.icon, styles.navigationNextIcon)} />
            </Button>
        </div>
    );
};

export { ImageGalleryControl };
